import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

const Color = () => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e.title.toLowerCase().includes(query.toLowerCase())).slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const deleteItem = async (id: number) => {
    if (confirm('آیا مطمئن هستید؟')) {
      dispatch(setLoading(true));

      const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/color/' + id, true).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: 'موفق',
          text: 'برند با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        });
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }
      dispatch(setLoading(false));
      await fetchData();
    }
  };

  const list = () => {
    const rows = [];

    data.filter((color: any) => color.title.toLowerCase().includes(query.toLowerCase())).map((color: any, index) => {
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(color.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/color/edit/' + color.id)}></i>
          </td>
          <td className="">{color.code}</td>
          <td className="">{color.title}</td>
          <td>{++index}</td>
        </tr>
      );
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.color.index).get();

    if (res.code == 200) {
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست رنگ ها </h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable" onClick={() => navigate('/color/add')}>
            <p>افزودن رنگ جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="listTable">
          <thead>
          <tr className="firstTR">
            <th>عملیات</th>
            <th>کد</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
        <ReactPaginate
          breakLabel="..."
          nextLabel="بعدی >"
          onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< قبلی"
          renderOnZeroPageCount={null}
          className="pagination"
          pageClassName="paginationBreak"
          previousClassName="paginationBreak"
          nextClassName="paginationBreak"
          activeClassName="paginationActive"
        />
      </main>
      </body>
    </>
  );
};
export default Color;